import THREE from "realms-three";

/**
 * Runs a callback on each material in the root object recursively
 */
export function forEachMaterial(
  root: THREE.Object3D,
  callback: (material: THREE.Material) => void
) {
  const material = (root as any)["material"];
  if (material instanceof THREE.Material) {
    callback(material);
  }
  for (const child of root.children) {
    forEachMaterial(child, callback);
  }
}
